import React from 'react';
import { observer } from 'mobx-react-lite';
import nanoid from 'nanoid';
import { useStores } from 'hooks/useStores';
import SidebarBlock from './components/SidebarBlock';

const Sidebar = observer(() => {
  const {
    advertsStore: { currentAdvert },
  } = useStores();

  const isRoadTrain = !!currentAdvert.advert_items;

  if (isRoadTrain) {
    return currentAdvert.advert_items.map((item) => {
      const uniqueId = nanoid();
      return (
        <SidebarBlock
          key={uniqueId}
          advert={currentAdvert}
          item={item.transport}
          type={item.type}
        />
      );
    });
  }

  return (
    <SidebarBlock
      advert={currentAdvert}
      item={currentAdvert.advert_item}
      type={currentAdvert.advert_item_type}
    />
  );
});

export default Sidebar;
